module.exports = __webpack_public_path__ + "img/billet.500be6cc.jpeg";